import React from "react";
import PropTypes from "prop-types";
import "react-dropdown/style.css";
import PhanTrang from "components/CommonComponent/PhanTrang";
import ReactDropdown from "react-dropdown";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { KhachHangCombo } from "constants/khachHangConst";
import KhachHangConst from "constants/khachHangConst";
import { TooltipBootrap } from "components/GenericComponent/TooltipBootrap";
import ThemMoiKhachHang from "containers/DanhSachKhachHang/ThemMoiKhachHang";
import Layout from "containers/Layout";
import NguonKhachHang from "components/CommonComponent/NguonKhachHang";
import NhapDsKhachHang from "components/CommonComponent/NhapDsKhachHang";
import { getDate } from "utils/formatDate";
import configs from "constants/configs";
import CustomerDetail from "containers/Common/Customer/customerDetail";
import DeleteKhachHang from "./DeleteKhachHang";
class DanhSachKhachHang extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showThemMoiKhachHang: false,
      showNguonKhachHang: false,
      showNhapDsKhachHang: false,
      showChiTietKhachHang: false,
      showXoaKhachHang: false,
      CustomerIdDetete: 0,
      khachHangDetail: {},
      dataSearch: {
        tenKH: "",
        loaiKH: -1, //Tất cả
        tinhtrangKH: -1, //Tất cả
        trangthaiKH: -1, //Tất cả
        nguonKH: 0, //Tất cả
        pageIndex: 1,
        pageSize: 25,
      },
    };
  }
  componentDidMount() {
    document.title = "Danh sách khách hàng | Phần mềm quản lý cầm đồ Morman";
    let { dataSearch } = this.state;
    let { getComboNguonKhachHang } = this.props;
    this.loadDanhSachKhachHang(dataSearch);
    getComboNguonKhachHang();
    // let {
    //   comboNguonKhachHang
    // }= this.props;
    // getComboNguonKhachHang();
  }
  loadDanhSachKhachHang(dataSearch) {
    let { getListDanhSachKhachHang } = this.props;
    getListDanhSachKhachHang(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  //SET TÌM KIỂM
  _onSelect = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    this.setState({ dataSearch });
  };
  onChangeData = (field, event) => {
    let { dataSearch } = this.state;
    dataSearch[field] = event.target.value;
    this.setState({ dataSearch });
  };

  onSearch = () => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadDanhSachKhachHang(dataSearch);
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadDanhSachKhachHang(dataSearch);
    }
  };

  setModalShow = () => {
    this.setState({ showThemMoiKhachHang: !this.state.showThemMoiKhachHang });
  };

  setModalNguonKhachHangShow = () => {
    this.setState({ showNguonKhachHang: !this.state.showNguonKhachHang });
  };
  setModalNhapDsKhachHangShow = () => {
    this.setState({ showNhapDsKhachHang: !this.state.showNhapDsKhachHang });
  };

  //HIỂN THỊ CHI TIẾT KHÁCH HÀNG
  setModalChiTietKhachHangShow = (khachHangDetail) => () => {
    let { showChiTietKhachHang } = this.state;
    if (khachHangDetail)
      this.setState({
        showChiTietKhachHang: !showChiTietKhachHang,
        khachHangDetail,
      });
    else this.setState({ showChiTietKhachHang: !showChiTietKhachHang });
  };

  //LẤY URL IMAGE
  getUrlImage(img) {
    // let image = img
    //   ? configs.imageServer + img
    //   : "/app-assets/images/no_image.png";
    // if (img && img.indexOf("http") > -1) image = img;

    let image = img;
    if (typeof img === "undefined" || img === "") {
      image = "Image/no_image.png";
    }
    if (image.indexOf("http") > -1) {
    } else {
      image = configs.apiViewUpload + image;
    }

    return image;
  }
  //PHÂN TRANG
  handlePageChange = (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadDanhSachKhachHang(dataSearch);
  };
  handlePageSizeChange = (pageSize) => {
    let { dataSearch } = this.state;
    dataSearch.pageSize = pageSize;
    dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadDanhSachKhachHang(dataSearch);
  };

  onDeleteKhachHang = (CustomerID) => () => {
    let { showXoaKhachHang } = this.state;
    this.setState({ CustomerIdDetete: CustomerID });
    if (CustomerID > 0) {
      this.setState({ showXoaKhachHang: !showXoaKhachHang });
    } else {
      this.setState({ showXoaKhachHang: false });
    }
  };

  renderTableRows() {
    let { danhsachkhachhang } = this.props;

    return danhsachkhachhang.objList.List.map((item, index) => (
      <div className="custom-table-row" key={"item" + index}>
        <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
          <span className="mobile-column-name">STT</span>
          <div className="center-wrapper">
            <p className="text-center">{item.IndexId}</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-14 flex-basis-15-6-sm">
          <span className="mobile-column-name">Tên khách hàng</span>
          <div className="center-wrapper">
            <p>
              <a
                href={() => false}
                className="blue btn-link"
                onClick={this.setModalChiTietKhachHangShow(item)}
              >
                {item.GetFullName}
              </a>
              <br />
              {item.Phone != "" ? " (ĐT:" + item.Phone + ")" : ""}
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-9 flex-basis-7-sm">
          <span className="mobile-column-name">Ngày sinh</span>
          <div className="center-wrapper">
            <p className="text-center">{getDate(item.Birthday)}</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-12 flex-basis-12-8-sm">
          <span className="mobile-column-name">Số CCCD</span>
          <div className="center-wrapper">
            <p className="text-center"> {item.CMT}</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-12 flex-basis-14-sm">
          <span className="mobile-column-name">Địa chỉ</span>
          <div className="center-wrapper">
            <p className="text-left">{item.Address}</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
          <span className="mobile-column-name">Đối tác</span>
          <div className="center-wrapper">
            <p className="text-center">
              {item.IsCus ? "Khách hàng" : "Đối tác"}
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-10 flex-basis-6-sm">
          <span className="mobile-column-name">Tình trạng</span>
          <div className="center-wrapper">
            <p className="text-center">
              <span
                className={
                  item.DebtLevel === KhachHangConst.TinhTrangKhachHang.NoXau
                    ? "canh-bao-red"
                    : item.DebtLevel === KhachHangConst.TinhTrangKhachHang.RuiRo
                    ? "canh-bao-no"
                    : "dang-vay"
                }
              >
                {KhachHangConst.TinhTrangKhachHangText[item.DebtLevel]}
              </span>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
          <span className="mobile-column-name">Ảnh</span>
          <div className="center-wrapper">
            <p className="text-center ava-kh">
              <TooltipBootrap
                contentText={
                  <div>
                    <img src={this.getUrlImage(item.Img)} alt="" />
                  </div>
                }
                titleText=""
                trigger={["hover", "focus"]}
                placement={"left"}
              >
                <a href={() => false}>
                  <img
                    className="img-responsive"
                    src={this.getUrlImage(item.Img)}
                    alt=""
                  />
                </a>
              </TooltipBootrap>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-5 flex-basis-12-6-sm  action-cell">
          <div className="center-wrapper">
            <div className="iconTableMormanCenter">
              <a href={() => false}>
                <PopoversBootrap
                  contentText="Sửa"
                  titleText=""
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <i className="mdi mdi-pencil-circle"></i>
                </PopoversBootrap>
              </a>
              {item.IsDelete == "1" && (
                <a
                  href={() => false}
                  onClick={this.onDeleteKhachHang(item.CustomerID)}
                >
                  <PopoversBootrap
                    contentText="Xoá"
                    titleText=""
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <i className="mdi mdi-delete"></i>
                  </PopoversBootrap>
                </a>
              )}

              {/* <a href={() => false} onClick={this.setModalNguonKhachHangShow}>
                <PopoversBootrap
                  contentText="Nguồn khách hàng"
                  titleText=""
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <i className="mdi mdi-account-group"></i>
                </PopoversBootrap>
              </a> */}
            </div>
          </div>
        </div>
      </div>
    ));
  }

  render() {
    let {
      khachHangDetail,
      dataSearch,
      showThemMoiKhachHang,
      showNguonKhachHang,
      showNhapDsKhachHang,
      showChiTietKhachHang,
      showXoaKhachHang,
      CustomerIdDetete,
    } = this.state;

    let { danhsachkhachhang, nguonkhachhang } = this.props;
    let { getListDanhSachKhachHangLoading } = danhsachkhachhang;
    let { comboNguonKhachHang } = nguonkhachhang;
    let { TotalQuantity } = danhsachkhachhang.objList;
    return (
      <Layout>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12  col-md-9 title-cd">
                      <div className="media-home align-center-home">
                        <div className="bg-icon-bredcrumb">
                          <i className="mdi mdi-account-group"></i>
                        </div>
                        <div className="media-body-home">
                          <h2 className="text-info-home">
                            Danh sách khách hàng
                          </h2>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-3 d-flex just-end hidden-mobile-main"></div>
                  </div>
                </div>

                <div className="search-new hidden-mobile-main show-table-main">
                  <div className="input-sm-new input-new-18">
                    <input
                      type="text"
                      className="form-control input-sm"
                      placeholder="Tên, sđt khách hàng"
                      onChange={this.onChangeData.bind(this, "tenKH")}
                      onKeyDown={this.handleKeyDown}
                      value={dataSearch.tenKH}
                    />
                  </div>

                  <div className="input-sm-new input-new-18">
                    <ReactDropdown
                      onChange={this._onSelect("loaiKH")}
                      options={KhachHangCombo.LoaiDoiTacCombo}
                      placeholder="Đối tác"
                      controlClassName="form-control input-sm"
                    />
                  </div>

                  <div className="input-sm-new input-new-18">
                    <ReactDropdown
                      onChange={this._onSelect("tinhtrangKH")}
                      options={KhachHangCombo.TinhTrangKhachHangCombo}
                      placeholder="Tình trạng"
                      controlClassName="form-control input-sm"
                      value={dataSearch.debt}
                    />
                  </div>

                  <div className="input-sm-new input-new-18">
                    <ReactDropdown
                      onChange={this._onSelect("trangthaiKH")}
                      options={KhachHangCombo.TrangThaiCombo}
                      placeholder="Trạng thái"
                      controlClassName="form-control input-sm"
                    />
                  </div>

                  <div className="input-sm-new input-new-18">
                    <ReactDropdown
                      onChange={this._onSelect("nguonKH")}
                      options={comboNguonKhachHang}
                      placeholder="Nguồn khách hàng"
                      controlClassName="form-control input-sm"
                    />

                    {/* <select
                                className="form-control input-sm"
                                ref={register}
                                name="customer.NguonKhId"
                                value={NguonKhId}
                                onChange={this.onChangeData("NguonKhId")}
                              >
                                {comboNguonKhachHang.map((item) => (
                                  <option value={item.value} key={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select> */}
                    {/* <ReactDropdown
                      onChange={this._onSelect("userName")}
                      options={props.comboNguonKhachHang}
                      placeholder="Nguồn khách hàng"
                      controlClassName="form-control input-sm"
                      value={dataSearch.nguonKH}
                    /> */}
                  </div>

                  <div className="input-sm-new input-new-18 search-main-new">
                    <button
                      type="submit"
                      className="btn btn-info-new"
                      onClick={this.onSearch}
                    >
                      <i className="la la-search"></i>
                    </button>
                  </div>
                </div>

                <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                  <div data-repeater-list="car">
                    <div data-repeater-item className="">
                      <form className="form row bg-search-form form-mobile-search">
                        <div className="mb-1 ">
                          <button
                            type="button"
                            className="btn btn-border-new"
                            onClick={this.setModalShow}
                          >
                            <i className="mdi mdi-plus"></i> Thêm mới
                          </button>
                        </div>

                        <div className="text-right left-search search-p mb-1 ">
                          <div className="search-mobile-new">
                            <fieldset className="form-group position-relative mb-0">
                              <input
                                type="text"
                                className="form-control input-sm"
                                id="iconLeft1"
                                placeholder="Tên, mã, sđt khách hàng ..."
                              />
                              <div className="form-control-position">
                                <i className="mdi mdi-magnify"></i>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="iconbutton-new hidden-mobile-main show-table-main">
                  <div className="row">
                    <div className="col-sm-12 col-md-9">
                      <button
                        type="button"
                        className="btn btn-border-new"
                        onClick={this.setModalShow}
                      >
                        <i className="mdi mdi-plus"></i> Thêm mới
                      </button>
                    </div>
                    <div className="col-sm-12 col-md-3 d-flex just-end">
                      <div className="btn-group btn-light-new1">
                        <ul>
                          <li>
                            {" "}
                            <a
                              href={() => false}
                              className="icon-bgnew color-print1"
                              onClick={this.setModalNhapDsKhachHangShow}
                            >
                              <PopoversBootrap
                                contentText="Nhập DSKH từ file Excel"
                                titleText=""
                                trigger={["hover", "focus"]}
                                placement={"top"}
                              >
                                <i className="mdi mdi-download"></i>
                              </PopoversBootrap>
                            </a>
                          </li>
                          <li>
                            {" "}
                            <a
                              href={() => false}
                              className="icon-bgnew color-print1"
                            >
                              <PopoversBootrap
                                contentText="Xuất DSKH ra file Excel"
                                titleText=""
                                trigger={["hover", "focus"]}
                                placement={"top"}
                              >
                                <i className="mdi mdi-upload"></i>
                              </PopoversBootrap>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="Left808x200 Table-main-new">
            {
              <div className="loading-page1">
                <div
                  className={
                    "loader loader-default " +
                    (getListDanhSachKhachHangLoading ? "is-active" : "")
                  }
                ></div>
              </div>
            }
            <div className="table-mobile sticky-table-bh1 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br /> <span className="red">[{TotalQuantity}]</span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-14 flex-basis-15-6-sm">
                    <p>Tên khách hàng</p>
                  </div>
                  <div className="custom-table-header flex-basis-9 flex-basis-7-sm">
                    <p className="text-center">Ngày sinh</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-12-8-sm">
                    <p className="text-center">Số CCCD</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-14-sm">
                    <p className="text-left">Địa chỉ</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                    <p className="text-center">Đối tác</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-6-sm">
                    <p className="tab-header text-center">Tình trạng</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                    <p className="text-center">Ảnh</p>
                  </div>
                  <div className="custom-table-header flex-basis-5 flex-basis-12-6-sm">
                    <p className="tab-header">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  {this.renderTableRows()}
                </div>
              </div>
            </div>
          </div>
          <div className="card border-light mb-3 card-v2">
            <div className="card-body card-body-v2">
              <PhanTrang
                pageIndex={dataSearch.pageIndex}
                pageSize={dataSearch.pageSize}
                totalCount={TotalQuantity}
                onPageChange={this.handlePageChange}
                onPageSizeChange={this.handlePageSizeChange}
              />
            </div>
          </div>
        </div>

        <ThemMoiKhachHang
          show={showThemMoiKhachHang}
          onHide={this.setModalShow}
          onSearch={this.onSearch}
        ></ThemMoiKhachHang>
        <NguonKhachHang
          show={showNguonKhachHang}
          onHide={this.setModalNguonKhachHangShow}
        ></NguonKhachHang>
        <NhapDsKhachHang
          show={showNhapDsKhachHang}
          onHide={this.setModalNhapDsKhachHangShow}
        ></NhapDsKhachHang>
        {showXoaKhachHang && (
          <DeleteKhachHang
            show={showXoaKhachHang}
            onHide={this.onDeleteKhachHang(0)}
            CustomerID={CustomerIdDetete}
            onSearch={this.onSearch}
          ></DeleteKhachHang>
        )}

        {showChiTietKhachHang && (
          <CustomerDetail
            show={showChiTietKhachHang}
            onHide={this.setModalChiTietKhachHangShow(khachHangDetail)}
            data={khachHangDetail}
            onSearch={this.onSearch}
          ></CustomerDetail>
        )}
      </Layout>
    );
  }
}

DanhSachKhachHang.propTypes = {
  getList: PropTypes.func,
};

export default DanhSachKhachHang;
